import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bold",
  "use": "icon-bold-usage",
  "viewBox": "-42 0 426 426.66667",
  "content": "<symbol viewBox=\"-42 0 426 426.66667\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bold\"><path d=\"m279.734375 197.566406c24.597656-20.5625 40.597656-51.070312 40.597656-85.566406 0-61.761719-50.238281-112-112-112h-186.664062c-11.777344 0-21.335938 9.535156-21.335938 21.332031s9.558594 21.335938 21.335938 21.335938h21.332031v341.332031h-21.332031c-11.777344 0-21.335938 9.535156-21.335938 21.332031s9.558594 21.335938 21.335938 21.335938h197.332031c67.625 0 122.667969-55.019531 122.667969-122.667969 0-45.546875-25.003907-85.269531-61.933594-106.433594zm-71.402344-154.898437c38.230469 0 69.335938 31.101562 69.335938 69.332031s-31.105469 69.332031-69.335938 69.332031h-122.664062v-138.664062zm10.667969 341.332031h-133.332031v-160h133.332031c44.117188 0 80 35.902344 80 80s-35.882812 80-80 80zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bold.svg
// module id = sMa1
// module chunks = 102